import { BuildInput } from './input'
import { IDatePicker, IField, IFile, IMultiFile } from '../../constants'
import { BuildFile } from './file'
import { BuildDatePicker } from './datePicker'
import { BuildSelect } from './select'
import { BuildMultiFile } from './multiFile'
import { BuildCheckbox } from './checkbox'
import { BuildActiveCheckbox } from './activeCheckbox'

export function BuildField(
  item: IField | IDatePicker | IFile | IMultiFile,
  key: string | number
): any {
  switch (item.type) {
    case 'datePicker': {
      return BuildDatePicker(item as IDatePicker, key)
    }
    case 'uploadImage':
      return BuildFile(
        {
          ...(item as IFile),
          acceptedFile: 'image/*'
        },
        key
      )
    case 'multiFile':
      return BuildMultiFile(
        {
          ...(item as IMultiFile),
          acceptedFile: '**'
        },
        key
      )
    case 'uploadVideo':
      return BuildFile(
        {
          ...(item as IFile),
          acceptedFile: 'video/*'
        },
        key
      )
    case 'select':
      return BuildSelect(item as IField, key)
    case 'checkbox':
      return BuildCheckbox(item as IField, key)
    case 'activeCheckbox':
      return BuildActiveCheckbox(item as IField, key)
    case 'texteditor':
    case 'text':
    case 'textarea':
    case 'url':
    default:
      return BuildInput(item as IField, key)
  }
}
